import UpdateCategoryTranslationRequest from '../../../../../Spirit/Admin/Interfaces/Models/MeditationService/UpdateCategoryTranslationRequest';

export default class UpdateCategoryRequest  {
	Id?: number = null;
	Translations: Array<UpdateCategoryTranslationRequest> = null;
	constructor(obj?: Partial<UpdateCategoryRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
